
export default function Disclaimer(props) {

  return <span className={ "text-disclaimer " + (props.className || '')} dangerouslySetInnerHTML={{__html: '<span>' + props.disclaimer + '</span>' }}></span>

}